export default {
  meta: {
    title: '用户管理',
    url: '/organization/user', // 埋点用，记录所属模块
    // eventId: '364a2abd-0f34-4158-9324-381466bc9c0f'
  }
};
